import PropTypes from 'prop-types';
import {useEffect} from 'react';
import {connect} from 'react-redux';
import WebLoyaltyVersion from '../../../enums/WebLoyaltyVersion';
import doMetric from '../../../v2/tracking/bigQueryMetricRecorder';
import Track from '../../../v2/utils/tracking';
import getWebLoyaltyHash from '../../../v2/webloyalty/getWebLoyaltyHash';
import WebLoyalty from './WebLoyalty';
import WebLoyaltyMatch from './WebLoyaltyMatch';

export function WebLoyaltyArbiter(props) {
  useEffect(() => {
    if (props.webLoyaltyVersion) {
      try {
        doMetric('WebLoyalty', [{name: 'loaded', value: true}], [], 'impression');
      } catch (error) {
        Track.track(error);
      }
    }
  }, [props.webLoyaltyVersion]);
  
  if (props.webLoyaltyVersion === WebLoyaltyVersion.WEBLOYALTY_MATCH) {
    return (
      <WebLoyaltyMatch {...props} />
    );
  }
  
  if (props.webLoyaltyVersion === WebLoyaltyVersion.WEBLOYALTY_DEFAULT) {
    return (
      <WebLoyalty {...props} />
    );
  }
  
  return null;
}

const mapStateToProps = (state, ownProps) => ({
  webLoyalty: getWebLoyaltyHash(ownProps.webLoyaltyVersion)(state),
});

WebLoyaltyArbiter.propTypes = {
  webLoyalty: PropTypes.shape({
    hash: PropTypes.string.isRequired,
  }).isRequired,
  isNewGuestUpdatedPage: PropTypes.bool,
  isMobile: PropTypes.bool,
  webLoyaltyVersion: PropTypes.string,
  email: PropTypes.string,
};

export default connect(mapStateToProps)(WebLoyaltyArbiter);
